export default __webpack_public_path__ + "src/images/packages/witklipfontein-eco-lodge/7b191b4d3ce358ed7b53dd413dde60ea-2.jpg";